import { hasValue, isEmail } from '../../services/validations'

type FieldTypes = { [key: string]: string }

type FieldValidationTypes = {
  values: FieldTypes
  fieldName: string
  errors: FieldTypes
}

const validateFirstName = ({
  values,
  fieldName,
  errors,
}: FieldValidationTypes): void => {
  const fieldValue = values[fieldName]

  if (!hasValue(fieldValue)) {
    errors[fieldName] = 'First name field is required.'
  }
}

const validateLastName = ({
  values,
  fieldName,
  errors,
}: FieldValidationTypes): void => {
  const fieldValue = values[fieldName]

  if (!hasValue(fieldValue)) {
    errors[fieldName] = 'Last name field is required.'
  }
}

const validateEmail = ({
  values,
  fieldName,
  errors,
}: FieldValidationTypes): void => {
  const fieldValue = values[fieldName]

  if (!hasValue(fieldValue)) {
    errors[fieldName] = 'Email field is required.'
    return
  }

  if (!isEmail(fieldValue)) {
    errors[fieldName] = 'Please input an email address.'
  }
}

const validatePhone = ({
  values,
  fieldName,
  errors,
}: FieldValidationTypes): void => {
  const fieldValue = values[fieldName]

  if (!hasValue(fieldValue)) {
    errors[fieldName] = 'Phone field is required.'
    return
  }
}

const validateCity = ({
  values,
  fieldName,
  errors,
}: FieldValidationTypes): void => {
  const fieldValue = values[fieldName]

  if (!hasValue(fieldValue)) {
    errors[fieldName] = 'City field is required.'
  }
}

const validateStateRegion = ({
  values,
  fieldName,
  errors,
}: FieldValidationTypes): void => {
  const fieldValue = values[fieldName]

  if (!hasValue(fieldValue)) {
    errors[fieldName] = 'Region/State field is required.'
  }
}

const InquireNowFormValidation = (values: {}): {} => {
  const errors = {}

  validateFirstName({ values, fieldName: 'first_name', errors })
  validateLastName({ values, fieldName: 'last_name', errors })
  validateEmail({ values, fieldName: 'email', errors })
  validatePhone({ values, fieldName: 'mobile', errors })
  validateCity({ values, fieldName: 'city', errors })
  validateStateRegion({ values, fieldName: 'state_region', errors })

  return errors
}

export default InquireNowFormValidation
